import { ClassicPreset } from "rete";
import { Container } from 'inversify';
import { IapWorkFlowActivity } from "../../../../domain/service/iapWorkFlowActivity";
import { Router } from 'vue-router';

export class MessageControl extends ClassicPreset.Control {
  constructor(public rootComponentInputId: number, public currentComponentInputId: number,public applicationId: number, public applicationVersion: number, public variableMsgInput: string, public variableMsgInputType: number, public variableMsgModalInput: boolean, container: Container | undefined, storeInput: any, itemActivity: IapWorkFlowActivity | undefined, public onChange: (evt: any) => void,public getNode: (evt: any) => void, public showExpression:(evt:any) => void) {
    super();
  }
}